import { useCallback, useEffect, useState } from 'react';
import { TrimUiManager } from '../../../trim-editor/manager/ui/trim.ui.manager';
import { NumInput } from '../input/numInput';
import RangeSlider from '../input/range-slider';
import './zoom-controller.scss';
import { NumUpDown } from '../input/num-up-down';

type Props = {
  zoomScale: number,
  min?: number,
  max?: number,
  callback: (n: number) => void
}
const ZoomController = (props: Props) => {
  const { zoomScale, min = 10, max = 400, callback } = props;

  // const [zoomScale, setZoomScale] = useState(defaultScale);

  const onChangeZoom = useCallback((v: number) => {
    const scale = Math.floor(v);
    // setZoomScale(scale);
    callback(scale);
  }, []);

  // useEffect(() => {
  //   setZoomScale(defaultScale);
  // }, [defaultScale]);

  return (
    <div className="zoom_controller">
      <NumUpDown value={zoomScale} min={10} max={400} callback={onChangeZoom} onBlur={(e) => onChangeZoom(Number(e.target.value))} />
      <div className="zoom_controller__unit">%</div>
      <RangeSlider min={min} max={max} range={zoomScale} callback={onChangeZoom} />
    </div>
  );
};

export default ZoomController;
